import React from 'react';

const ProfessionalSummaryForm = ({ data, onChange }) => {
  return (
    <div className="form-section">
      <h2 className="section-title">Professional Summary</h2>
      <p className="section-description">
        Write a compelling summary that highlights your key qualifications, experience, and career objectives. 
        Keep it concise (3-5 sentences) and focus on what makes you unique.
      </p>

      <div className="form-group">
        <label className="form-label">Summary</label>
        <textarea
          className="form-textarea"
          value={data}
          onChange={(e) => onChange(e.target.value)}
          placeholder="Results-driven professional with 5+ years of experience in software development. Proven track record of delivering high-quality solutions and leading cross-functional teams. Seeking to leverage expertise in full-stack development to drive innovation at a forward-thinking company."
          rows="8"
        />
        <p className="form-hint">
          💡 Tip: Start with your professional title, mention years of experience, highlight key skills, 
          and state your career goal or what you can bring to the role.
        </p>
      </div>

      <div className="example-box" style={{
        background: '#f0f7ff',
        padding: '1rem',
        borderRadius: '8px',
        marginTop: '1rem',
        fontSize: '0.9rem',
        color: '#2c3e50'
      }}>
        <strong>✨ Example:</strong>
        <p style={{ marginTop: '0.5rem', lineHeight: '1.6' }}>
          "Dynamic Marketing Manager with 7+ years of experience driving brand growth and customer engagement. 
          Expert in digital marketing strategies, data analytics, and team leadership. Successfully increased 
          revenue by 40% through innovative campaigns. Passionate about leveraging creative solutions to 
          achieve business objectives."
        </p>
      </div>
    </div>
  );
};

export default ProfessionalSummaryForm;
